module.exports = __webpack_public_path__ + "static/media/Culture and Team Fit.c55bd242.png";